// @flow
import type { RecordOf } from "immutable"
import type Moment from "moment"

type TripPart = RecordOf<{
  arrival: Map<{
    when: Map<{
      local: Moment,
    }>,
  }>,
  departure: Map<{
    when: Map<{
      local: Moment,
    }>,
  }>,
}>

export function isLocalOverNight(part: TripPart): boolean {
  return (
    part
      .get("arrival")
      .get("when")
      .get("local")
      .get("M") !==
      part
        .get("departure")
        .get("when")
        .get("local")
        .get("M") ||
    part
      .get("arrival")
      .get("when")
      .get("local")
      .get("D") !==
      part
        .get("departure")
        .get("when")
        .get("local")
        .get("D")
  )
}

export function showDate(
  prevPart: TripPart & { +isLocalOverNight: typeof isLocalOverNight },
  part: TripPart & { +isLocalOverNight: typeof isLocalOverNight },
) {
  return (
    prevPart
      .get("departure")
      .getIn(["when", "local"])
      .get("D") ===
      part
        .get("departure")
        .getIn(["when", "local"])
        .get("D") && !part.isLocalOverNight()
  )
}
